/** Remove a resumable upload write capability before exposing a read-only submission projection. */
export function redactSubmissionWriteCapability<T extends { resumableUri: string | null }>(
  session: T,
): T {
  return { ...session, resumableUri: null };
}
